var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("q-button", { staticClass: "upLoad-button" }, [
    _c("input", {
      staticClass: "file",
      attrs: { type: "file" },
      on: { change: _vm.onFileChange },
    }),
    _vm._v(" "),
    _c("span", { staticClass: "fake" }, [
      _vm._v(_vm._s(this.$qt("el.upload.buttonTitle"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }